/**
 * /auth/* 端点的瘦封装。
 * 后端见 app/auth/routes.py + service.py。
 */

import { http } from '@/api/http'

export interface AuthResponse {
  pid:      string
  name:     string
  money:    number
  is_admin: boolean
  token:    string
}

export interface LoginRequest {
  username: string
  password: string
}

export interface RegisterRequest {
  username:     string
  name:         string
  password:     string
  invite_code?: string
}

/** 登录, 失败抛 ApiError(code: 'error'/'detail') with HTTP 4xx。*/
export function login(req: LoginRequest): Promise<AuthResponse> {
  return http.post<AuthResponse>('/auth/login', req, { auth: false })
}

/** 注册, 第一个注册者会被后端自动标 is_admin=true。*/
export function register(req: RegisterRequest): Promise<AuthResponse> {
  return http.post<AuthResponse>('/auth/register', req, { auth: false })
}
